import { BoardCommond, enumOpType } from "./../types/index";
import { Commond, RoleCode } from "@/types";
import ee from "@/util/event";
import { EventEmitter } from 'events';

/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState, createRef, useRef } from "react";
import randomString from "random-string";
import {
  QRTCParams,
  QRTCVideoResolution,
  QRTCVideoResolutionMode,
  // QRTCVideoStreamType,
  QRTCVideoEncParams,
  QRTCMediaDeviceChangeEvent,
  QRTCErrorInfo,
  QRTCCodecType,
} from "@/qrtc_web_sdk/RoomParams";
import RoomClient from "@/qrtc_web_sdk/RoomClient100";
import { RtcType, ParticipantType, CALLBACK } from "@/types";
import { ConferenceInterface } from "@/types";
import { getPeer, getSelf } from "@/pages/Meeting/mtools";
import { METTINGPAGE_SAVED_MEETING_INFO } from "@/config/const";
import { storage, inElectron } from "@/util";
import { rtc2Web } from "@/util/transferdata";
import { message } from "antd";
import { isUndefined } from "lodash";
import { debug } from "console";
const packageJson = require('../../package.json');
const version = packageJson.version;

interface UserAudioTrack {
  userId: string;
  track: MediaStreamTrack;
}

let globalPeers: ParticipantType[] = [];
export const eventEmitter = new EventEmitter();

const useRtc = (options: any): RtcType => {
  //const whiteBoardDom = createRef<HTMLVideoElement>();
  // if (participants.length === 1) {
  //   d.isHost = true;
  //   d.roleCode = 20;
  // }
  const [speakerViewMode, setSpeakerViewMode] = useState("");


  const [participants, _setParticipants] = useState<ParticipantType[]>([
    {
      peerId: options.uid || randomString({ length: 8 }).toLowerCase(),
      peerName: options.username,
      local: true,
      raiseHandStatus: false,
      roleCode: getSelf(options.conf).roleCode,
      videoTrack: null,
      audioTrack: null,
      bInActivePage: true,
      isHost:false,
      sosPressed: false
    },
  ]);
  const [conference, setCoference] = useState<ConferenceInterface>(
    options.conf
  );

  const [boardItems, setBoardItems] = useState<Array<any>>([]);
  const [boardShow, setBoardShow] = useState(false);
  const boardSize = useRef({ w: 100, h: 100 });

  const setBoardSize = (f: any) => {
    boardSize.current = f;
  };

  //当传入一个函数时,该函数会接收先前的状态值作为参数,并返回一个用来更新状态的值。
  //例如: const [count, setCount] = useState(0); 
  // 直接设置值
  //setCount(10);
  // 函数设置 
  //setCount(prevCount => prevCount + 1);

  const setParticipants = (cb: CALLBACK) => {
    _setParticipants((peers) => {
      //快速会议
      // if (peers.length === 1) {
      //   peers[0].isHost = true;
      //   peers[0].roleCode = 20;
      // }
      globalPeers = cb(peers);
      console.log(`[use-rtc] setParticipants globalPeers=${JSON.stringify(globalPeers)} peers=${JSON.stringify(peers)}`);
      return globalPeers;
    });
  };

  const setSOS = ( peerId: string , sosValue: boolean) => {
    setParticipants((peers) =>
      peers.map((d) => {
        if (d.peerId === peerId) {
          return {
            ...d,
            sosPressed: sosValue,
          };
        }
        return d;
      })
    );
  }

  useEffect(() => {
    init();
    return () => {
      close();
    };
  }, []);
 // 新增函数设置主屏发言人
 const setMainSpeaker = (userId: string) => {
    // setMainSpeakerId(userId); // Replace setMainSpeakerId with setMainSpeaker
  // 这里可以添加逻辑以确保主屏显示指定的发言人视频
  // 例如，你可以调整 participants 数组的顺序，使得主发言人位于数组的第一个位置
  setParticipants((peers) => {
    const mainSpeakerIndex = peers.findIndex((peer) => peer.peerId === userId);
    if (mainSpeakerIndex !== -1) {
      const mainSpeaker = peers[mainSpeakerIndex];
      const updatedPeers = [mainSpeaker, ...peers.filter((peer) => peer.peerId !== userId)];
      return updatedPeers;
    }
    return peers;
  });
};
  const init = async () => {
    const roomClient = new RoomClient();
    window.roomClient = roomClient;


  //   setParticipants((peers) =>
  //   peers.map((d) => {
  //     if (d.peerId === userId) {
  //       if(!d.videoTrack){
  //         return { ...d, video: true, videoTrack: remoteTrack };
  //       }
  //     }
  //     return d;
  //   })
  // );
  //监听语音激励事件
    roomClient.on("userSpeaking", function(data) {
      // console.log("User speaking 语音激励 received:", JSON.stringify(data) );
      // console.log("User speaking 语音激励 发言人:",  data.userId );
      // console.log("User speaking 语音激励 嗓门:",  data.action );
      if (speakerViewMode === "speaker") {
        setMainSpeaker(data.userId);
      }
    });
    //已进入房间  enterRoom
    roomClient.on("enterRoom", async () => {
      console.warn(`[APP] enterRoom!!!!!!!`,conference);
      //进了房间，有可能是第一次进，也有可能是重连进，所以此时要确保participants里面只有自己
      //判断本地音频和视频是否需要开启
       
      if(options.audio){
        //开启本地音频
        await window.roomClient.startLocalAudio()
      }
      if(options.simulcast){
        //开启本地视频
         
        window.roomClient.enableEncSmallVideoStream(true);
      }
      let localTrack: MediaStreamTrack | null = null; // 显式类型注解
      if(options.video){
        //开启本地视频
         
        localTrack =await window.roomClient.publishVideo();
        // setParticipants((peers) => {
        //   return peers.filter((d) => d.local).map((d) => {
        //     return { ...d, video: options.video, audio: options.audio, videoTrack: localTrack };
        //   });
        // });
        //   return peers.map((d) => {
        //     if (d.local) {
        //       return { ...d, video: options.video, audio: options.audio, videoTrack: localTrack };
        //     }
        //     return { ...d };
        //   });
        // });
      }
      //然后再触发UI重新渲染
      setParticipants((peers) => {
        // return peers.filter((d) => d.local).map((d) => {
        //   return { ...d, video: options.video, audio: options.audio };
        // });
        return peers.map((d) => {
          if (d.local) {
            return { ...d, video: options.video, audio: options.audio, videoTrack: localTrack as any };
          }
          return { ...d };
        });
      });
    });

    //已离开房间 tcp dump zhua bao
    roomClient.on("exitRoom", async () => {});
    
    roomClient.on("hostLeaveMsg", async (data) => {
      //  console.log("主持人离开!!!!",data)
       conference. isHostLeave= true;
    })
    //与服务器的连接断开
    roomClient.on("disconnected", () => {
      console.log("[App] disconnected");
      //重置participants为只有自己
      setParticipants((peers) => peers.filter((d) => d.local));
    });
    roomClient.on("connectionGone", () => {
      console.log("[App] connectionGone");
    });

    //有人加入房间 !!!!! remoteUserEnterRoom
    roomClient.on("remoteUserEnterRoom", (userInfo) => {
      setParticipants((peers) => {
        console.log(`[APP] remoteUserEnterRoom userInfo=${JSON.stringify(userInfo)}`);
         console.log(`[APP] remoteUserEnterRoom peers=${JSON.stringify(peers)}`);
        //  peers.forEach((d) => { 
        //     d.roleCode=0;
        //     d.isHost =false
        //  })
        const samePeer = peers.find((x) => x.peerId === userInfo.userId);
        const apeer = getPeer(
          options.conf,
          { peerId: userInfo.userId },
          globalPeers
        );
        console.log(`[APP] remoteUserEnterRoom samePeer=${JSON.stringify(samePeer)} apeer=${JSON.stringify(apeer)}`)
        // if(samePeer  === undefined){
          
        //   apeer.roleCode=0;
        //   apeer.isHost =false
        // }
        return samePeer
          ? peers
          : [
              ...peers,
              {
                peerId: userInfo.userId,
                peerName: userInfo.userName,
                roleCode: apeer.roleCode,
                raiseHandStatus: apeer.raiseHandStatus,
                videoTrack: null,
                audioTrack: null,
                bInActivePage: false,
                isHost:apeer.isHost,
                sosPressed: false
              },
            ];
      });
    });

    //有人离开房间
    roomClient.on("remoteUserLeaveRoom", (userInfo) => {
      console.log("[App] userLeaveRoom:", userInfo);
      setParticipants((peers) =>
        peers.filter((d) => d.peerId !== userInfo.userId)
      );
    });

    // roomClient.on("userVideoSubscribed", (videoInfo) => {
    //   console.log("[TraceVideo] [APP] userVideoSubscribed", videoInfo);
    //   const { userId, track } = videoInfo;
    //   setParticipants((peers) =>
    //   peers.map((d) => {
    //     if (d.peerId === userId) {
    //       return {
    //         ...d,
    //         videoTrack: track,
    //       };
    //     }
    //     return d;
    //   })
    // );
    // });

    // roomClient.on("userVideoUnsubscribed", (videoInfo) => {
    //   console.log("[TraceVideo] [APP] userVideoUnsubscribed", videoInfo);
    //   const { userId } = videoInfo;
    //   setParticipants((peers) =>
    //   peers.map((d) => {
    //     if (d.peerId === userId) {
    //       return {
    //         ...d,
    //         videoTrack: null,
    //       };
    //     }
    //     return d;
    //   })
    // );
    // });

    //有人开始推视频流
    roomClient.on("userVideoAvailable", async (videoInfo) => {
      
      const { userId, available } = videoInfo;
      //console.log(`[DEBUG] [TraceVideo] [APP] userVideoAvailable userId=${userId} available=${available} participants=${JSON.stringify(globalPeers)}`);
      //拉取一下视频流
      for (const participant of globalPeers) {
        //console.log(`[DEBUG] [TraceVideo] [APP] userVideoAvailable for loop participant.peerId=${participant.peerId} userId=${userId} bInActivePage=${participant.bInActivePage}`);
        if (participant.peerId === userId) {
          if (available) {
            if (participant.bInActivePage) {
              console.log(`[DEBUG] [TraceVideo] [APP] userVideoAvailable userId=${userId} bInActivePage=${participant.bInActivePage}`)
              await startRemoteVideo(userId);
            }
          } else {
            console.log(`[DEBUG] [TraceVideo] [APP] userVideoAvailable  not in active page userId=${userId} bInActivePage=${participant.bInActivePage}`)
            await stopRemoteVideo(userId);
          }
          break;
        }
      }
      ee.emit("openVideo");
    });

    //有人开始推音频流
    roomClient.on("userAudioAvailable", async (audioInfo) => {
      console.log("[APP] userAudioAvailable", audioInfo);
      const { userId, available } = audioInfo;
      if (available) {
        //先拉取远端音频流
        try {
          setParticipants((peers) => {
            const newPeers = peers.map((d) => {
              if (d.peerId === userId) {
                return {
                  ...d,
                  audio: true,
                };
              }
              return { ...d };
            });
            return newPeers;
          });
          let audioTrack = await window.roomClient.subscribeAudio(userId);
        } catch (error) {
          setParticipants((peers) => {
            const newPeers = peers.map((d) => {
              if (d.peerId === userId) {
                return {
                  ...d,
                  audio: false,
                };
              }
              return { ...d };
            });
            return newPeers;
          });
        }
      }else{
        setParticipants((peers) => {
          const newPeers = peers.map((d) => {
            if (d.peerId === userId) {
              return {
                ...d,
                audio: false,
              };
            }
            return { ...d };
          });
          return newPeers;
        });
      }
    });

    //有人开始推桌面共享流
    roomClient.on("userShareAvailable", async (shareInfo) => {
      console.warn(`[App] userShareAvailable videoInfo`, shareInfo);
      const { userId, available } = shareInfo;
      if (available) {
        //拉取一下视频流
        await startRemoteShare(userId);
        // setParticipants((peers) => {
        //   const peer = peers.find((d) => d.peerId === userId);
        //   return [
        //     ...peers.filter((d) => !d.share),
        //     {
        //       peerId: `share_${userId}`,
        //       peerName: `${peer ? peer.peerName : ""}的分享`, // todo 用户名应由sdk返回
        //       share: true,
        //       video: true,
        //     },
        //   ];
        // });
        ee.emit("openshare");
      } else {
        //share is special no this person so when avaible is false we should stop share
        setParticipants((peers) => [...peers.filter((d) => !d.share)]);
      }
    });

    //我自己的桌面共享开始了
    roomClient.on("screenCaptureStarted", () => {});

    //我自己的桌面共享暂停了
    roomClient.on("screenCapturePaused", () => {});

    //我自己的桌面共享继续了
    roomClient.on("screenCaptureResumed", () => {});

    //我自己的桌面共享停止了
    roomClient.on("screenCaptureStoped", () => {});

    //用于提示音量大小的回调，包括每个 userId 的音量和远端总音量 如果没有人说话，则 userVolumes 为空，totalVolume 为0。
    //userVolumes	所有正在说话的房间成员的音量，取值范围0 - 100。
    //totalVolume	所有远端成员的总音量, 取值范围0 - 100。
    //userId 为 nil 时表示自己的音量，userVolumes 内仅包含正在说话（音量不为0）的用户音量信息。
    roomClient.on("activeSpeaker", (peerId) => {
      console.log("[APP] activeSpeaker");
      if (!peerId) {
        return;
      }

      const activePeer = globalPeers.find((d) => d.active);
      if (peerId && !activePeer) {
      }
      if (
        (!activePeer && peerId) ||
        (activePeer && activePeer.peerId !== peerId)
      ) {
        setParticipants((peers) =>
          peers.map((d) => {
            if (!d.active && d.peerId === peerId) {
              return {
                ...d,
                active: true,
              };
            }
            if (d.active && d.peerId !== peerId) {
              return {
                ...d,
                active: false,
              };
            }
            return d;
          })
        );
      }
    });

    roomClient.on("deviceChanged", (deviceEvent) => {
      switch (deviceEvent.event) {
        case QRTCMediaDeviceChangeEvent.QRTCMediaDevice_WebCamAdded:
          console.log(`[App] New camera id=${deviceEvent.deviceId}`);
          break;
        case QRTCMediaDeviceChangeEvent.QRTCMediaDevice_WebCamRemoved:
          console.log(`[App] Removed camera id=${deviceEvent.deviceId}`);
          break;
        case QRTCMediaDeviceChangeEvent.QRTCMediaDevice_MicAdded:
          console.log(`[App] New microphone id=${deviceEvent.deviceId}`);
          break;
        case QRTCMediaDeviceChangeEvent.QRTCMediaDevice_MicRemoved:
          console.log(`[App] Removed microphone id=${deviceEvent.deviceId}`);
          break;
        case QRTCMediaDeviceChangeEvent.QRTCMediaDevice_SpeakerAdded:
          console.log(`[App] New speaker id=${deviceEvent.deviceId}`);
          break;
        case QRTCMediaDeviceChangeEvent.QRTCMediaDevice_SpeakerRemoved:
          console.log(`[App] Removed speaker id=${deviceEvent.deviceId}`);
          break;
        default:
          break;
      }
    });

    roomClient.on("networkQuality", (qualityInfo) => {
      console.log(`[APP] networkQuality=${JSON.stringify(qualityInfo)}`);
    });

    roomClient.on("mute-audio", () => {});

    roomClient.on("mute-video", () => {});

    roomClient.on("unmute-audio", () => {});

    roomClient.on("unmute-video", () => {});

    roomClient.on("connection-state-changed", (event) => {
      //const prevState = event.prevState;
      //const curState = event.state;
    });

    //control
    roomClient.on("customCommand", (event) => {
      console.warn(`[customCommand]:`, event);
      console.log(`[customCommand!!!!!!!!]:`, event);
     
      const { command, from, to, room, metadata } = event;
      console.log(`[customCommand command!!!!!!!!]:`, command);
      console.log(`[customCommand from!!!!!!!!]:`, from);
      console.log(`[customCommand to!!!!!!!!]:`, to);
      console.log(`[customCommand metadata!!!!!!!!]:`, metadata);
      const { peerid:fromid } = from;
      const { peerid } = to;
      switch (command) {
        case Commond.automaticGrant: {
          // console.log("自动推举新主持人 is!!!!!!!",peerid) 
          //refresh member list
          eventEmitter.emit('automaticNewHostGrant', peerid,fromid);
          break;
        }
        case Commond.hostLeaveMeeting: { 
           
          // console.log("主持人离开!!!!!!!") 
          eventEmitter.emit('hostLeaveMeeting');
          break
        }
        // ========  mute
        // single mute
        case Commond.singleMute: {
          setParticipants((peers) => {
            const newPeers = peers.map((d) => {
              if (d.peerId === peerid) {
                return {
                  ...d,
                  audio: false,
                };
              }
              return { ...d };
            });
            return newPeers;
          });
          break;
        }
        // single unmute
        case Commond.singleUnMute: {
          setParticipants((peers) => {
            const newPeers = peers.map((d) => {
              if (d.peerId === peerid) {
                return {
                  ...d,
                  audio: true,
                };
              }
              return { ...d };
            });
            return newPeers;
          });
          break;
        }
        // all mute
        case Commond.allForceMute: {
          setParticipants((peers) => {
            const newPeers = peers.map((d) => ({
              ...d,
              audio: false,
            }));
            return newPeers;
          });
          break;
        }
        // all unmute
        case Commond.allUnMute: {
          setParticipants((peers) => {
            const newPeers = peers.map((d) => ({
              ...d,
              audio: true,
            }));
            return newPeers;
          });
          break;
        }
        // ========== video
        // shield
        case Commond.shieldVideos: {
          setParticipants((peers) => {
            const newPeers = peers.map((d) => {
              if (d.peerId === peerid) {
                return {
                  ...d,
                  video: false,
                };
              }
              return { ...d };
            });
            return newPeers;
          });
          break;
        }
        //open
        case Commond.openVideos: {
          setParticipants((peers) => {
            const newPeers = peers.map((d) => {
              if (d.peerId === peerid) {
                return {
                  ...d,
                  video: true,
                };
              }
              return { ...d };
            });
            return newPeers;
          });
          ee.emit("openVideo");
          break;
        }
        // ========= hand
        // single rise
        case Commond.raiseHand: {
          setParticipants((peers) => {
            const newPeers = peers.map((d) => {
              if (d.peerId === from.peerid) {
                return {
                  ...d,
                  raiseHandStatus: true,
                };
              }
              return { ...d };
            });
            return newPeers;
          });
          break;
        }
        // single down
        case Commond.singleHandsDown: {
          setParticipants((peers) => {
            const newPeers = peers.map((d) => {
              if (d.peerId === peerid) {
                return {
                  ...d,
                  raiseHandStatus: false,
                };
              }
              return { ...d };
            });
            return newPeers;
          });
          break;
        }
        // all down
        case Commond.allHandsDown: {
          setParticipants((peers) => {
            const newPeers = peers.map((d) => ({
              ...d,
              raiseHandStatus: false,
            }));
            return newPeers;
          });
          break;
        }

        // 修改权限..
        case Commond.grant: {
          console.log(`[use-rtc] grant peerid=${peerid} metadata=${metadata}`);
          setParticipants((peers) => {
            const newPeers = peers.map((d) => {
              if (d.peerId === peerid) {
                return {
                  ...d,
                  roleCode: +metadata as RoleCode,
                };
              }
              return { ...d };
            });
            return newPeers;
          });
          break;
        }
        // 移除人
        case Commond.removeUser: {
          setParticipants((peers) => peers.filter((d) => d.peerId !== peerid));
          options.emit("removeUser", peerid);
          break;
        }
        // 修改名称
        case Commond.changeNameByHost: {
          setParticipants((peers) => {
            const newPeers = peers.map((d) => {
              if (d.peerId === peerid) {
                return {
                  ...d,
                  peerName: metadata,
                };
              }
              return { ...d };
            });
            return newPeers;
          });
          break;
        }
//record
        case Commond.startRecord: {
          setParticipants((peers) => {
            const newPeers = peers.map((d) => {
              if(d.local){
                if(d.peerId === fromid){
                  console.log(`[use-rtc] myself startRecord`);
                  return {
                    ...d,
                    recording: true,
                  };

                }
              }
              return { ...d };
            });
            return newPeers;
          });
          break;
        }

        case Commond.stopRecord: {
          setParticipants((peers) => {
            const newPeers = peers.map((d) => {
              if(d.local){
                if(d.peerId === fromid){
                  console.log(`[use-rtc] myself startRecord`);
                  return {
                    ...d,
                    recording: false,
                  };

                }
              }
              return { ...d };
            });
            return newPeers;
          });
          break;
        }

        case Commond.pauseRecording: {
          setParticipants((peers) => {
            const newPeers = peers.map((d) => {
              if(d.local){
                if(d.peerId === fromid){
                  console.log(`[use-rtc] myself startRecord`);
                  return {
                    ...d,
                    recordingPaused: true,
                  };

                }
              }
              return { ...d };
            });
            return newPeers;
          });
          break;
        }

        case Commond.resumeRecording: {
          setParticipants((peers) => {
            const newPeers = peers.map((d) => {
              if(d.local){
                if(d.peerId === fromid){
                  console.log(`[use-rtc] myself startRecord`);
                  return {
                    ...d,
                    recordingPaused: false,
                  };
                }
              }
              return { ...d };
            });
            return newPeers;
          });
          break;
        }

        //livestreaming
        case Commond.startStreaming: {
          setParticipants((peers) => {
            const newPeers = peers.map((d) => {
              if(d.local){
                if(d.peerId === fromid){
                  console.log(`[use-rtc] myself startRecord`);
                  return {
                    ...d,
                    livestreaming: true,
                  };

                }
              }
              return { ...d };
            });
            return newPeers;
          });
          break;
        }

        case Commond.stopStreaming: {
          setParticipants((peers) => {
            const newPeers = peers.map((d) => {
              if(d.local){
                if(d.peerId === fromid){
                  console.log(`[use-rtc] myself startRecord`);
                  return {
                    ...d,
                    livestreaming: false,
                  };

                }
              }
              return { ...d };
            });
            return newPeers;
          });
          break;
        }

        case Commond.pauseStreaming: {
          setParticipants((peers) => {
            const newPeers = peers.map((d) => {
              if(d.local){
                if(d.peerId === fromid){
                  console.log(`[use-rtc] myself startRecord`);
                  return {
                    ...d,
                    isLiveStreamingPaused: true,
                  };

                }
              }
              return { ...d };
            });
            return newPeers;
          });
          break;
        }

        case Commond.resumeStreaming: {
          setParticipants((peers) => {
            const newPeers = peers.map((d) => {
              if(d.local){
                if(d.peerId === fromid){
                  console.log(`[use-rtc] myself startRecord`);
                  return {
                    ...d,
                    isLiveStreamingPaused: false,
                  };
                }
              }
              return { ...d };
            });
            return newPeers;
          });
          break;
        }

        default:
          break;
      }
    });
    roomClient.on("recvHostLeaveMsg", (obj: any) => {
      const { data: sdata, orderId } = obj;
      let cdata: any = {};
      try {
        cdata = JSON.parse(sdata);
      } catch (ex) {
        // 推流是每个摄像头起一个线程，所以会有多个推流
      }
      console.log("====recvHostLeaveMsg====", orderId, cdata);

    })
    // 白板之类的代码
    roomClient.on("recvCustomCmdMsg", (obj: any) => {
      const { data: sdata, cmdId } = obj;
      let cdata: any = {};
      try {
        cdata = JSON.parse(sdata);
      } catch (ex) {
        //
      }
      console.warn("====recvCustomCmdMsg====", cmdId, cdata);
      if (cdata.data) {
        cdata = cdata.data;
      }

      if( obj.data === "SOS" ){
        console.log("-------SOS--------")
        setSOS(obj.peerId,true);
        setTimeout(() => {
          setSOS(obj.peerId,false);
        }, 10000);
      }

      const data = Array.isArray(cdata) ? cdata[0] : cdata;
      if (cmdId === BoardCommond.BoardOpen) {
        setBoardShow(true);
        ee.emit("boardshow");
      } else if (cmdId === BoardCommond.BoardClose) setBoardShow(false);
      else if (cmdId === BoardCommond.BoardClear) {
        // 清除所有
        setBoardItems([]);
      } else if (cmdId === BoardCommond.BoardData) {
        const { type, name } = data;
        if (type === enumOpType.t_XiangPiCa) {
          setBoardItems((items) => {
            const newd = items.filter((d) => d.id !== name);
            return [...newd];
          });
        } else {
          const adata = rtc2Web(data, boardSize.current.w, boardSize.current.h);
          setBoardItems((items) => {
            return [...items, adata];
          });
        }
      }
      // }
    });

    roomClient.on('errorMsg',(code, errorData)=>{
      if(code == QRTCErrorInfo.ERR_MIC_NO_GRANT){
        message.error("会议密码错误");
      }
      
    })

    try {
      const conf: ConferenceInterface = storage.get(
        METTINGPAGE_SAVED_MEETING_INFO
      );
      //await roomClient.join()
      const roomInfo: QRTCParams = {
        serverUrl: "wss://rtc.callpro.mn/websocket3/", //'live.testgw.100tt.com.cn/signal-server', //'live.test.100tt.com.cn/signal-server', //'quickrtc.cn/websocket'
        sdkAppId: "eNxxUEd1GDqcw6SwMNN3Jy",
        userSig: "",
        userId: options.uid, //|| randomString({ length: 8 }).toLowerCase()}`,
        userName: options.username,
        roomId: options.roomId,
        maxRetryTime: 10 * 1000, //try one hour
        xConferenceToken: "001eJxTYLh3dLv75JhaIxXuxJAknt2r9t028X78cMJPKzOz1uDWb35iDKl+FRWhrimG7i6FyeVmweW+fn7GXpWWtt6pDFqloo+ENRgZGRgZWIAYxGcCk8xgkgVMKjCYp5gbGZuZpiZZWhibWJgaW5qnGqcap1mmmJgZJKWkJHIxGFlYGBmbGBqZGwMAfL8oEw==",
      };

      //设置默认编码参数
      const encoderParams: QRTCVideoEncParams = {
        // preferCodec: QRTCCodecType.QRTCCodec_H264Base,
        videoResolution: QRTCVideoResolution.QRTCVideoResolution_640_480,
        resMode: QRTCVideoResolutionMode.QRTCVideoResolutionModeLandscape,
        videoFps: 15,
        minVideoBitrate: 200,
        maxVideoBitrate: 500,
      };
      roomClient.setVideoEncoderParam(encoderParams);
      if (roomClient.enableEncSmallVideoStream(true) < 0) {
        //当前设置的分辨率无法开启大小流模式
      }
      console.log(`[USE-RTC] current version=${version}`)
      await roomClient.enterRoom(roomInfo);
      await roomClient.getCameraDeviceList();
    } catch (e) {
      console.error("join room failed! " + e);
    }

    console.log("join room success");
  };

  const setAudioPlayoutVolume = (volume: number) => {
    const audios = document.querySelectorAll("audio");
    window.roomClient.setAudioPlayoutVolume(audios, volume);
  };

  const setCurrentMic = async (v: string) =>
    await window.roomClient.setCurrentMic(v);
  const setCurrentCameraDevice = async (v: string) =>
    await window.roomClient.setCurrentCameraDevice(v);

  const setCurrentSpeaker = async (v: string) =>
    await window.roomClient.setCurrentSpeaker(v);

  //修改为推流成功后，改变participants
  const startLocalPreview = async () => {
    console.log(`[APP] startLocalPreview`);
    try {
      const localTrack = await window.roomClient.publishVideo();
      setParticipants((peers) =>
        peers.map((d) => {
          if (d.local) {
            return { ...d, video: true, videoTrack: localTrack };
          }
          return d;
        })
      );
    } catch (error) {

    }

  };

  //修改为停止流成功后，改变participants
  const stopLocalPreview = async () => {
    console.log(`[APP] stopLocalPreview`);
    try {
      await window.roomClient.unpublishVideo();
      setParticipants((peers) =>
        peers.map((d) => {
          if (d.local) {
            return { ...d, video: false, videoTrack: null };
          }
          return d;
        })
      );
    } catch (error) {

    }
  };

  //remote share也可以翻页吗，翻页了，是否包含在页面内，这些问题是要考虑的
  const startRemoteShare = async (userId: string) =>{
    //已经在subscribeShare中做了防止重复订阅的策略
    try {
      const remoteTrack = await window.roomClient.subscribeShare(userId);
      setParticipants((peers) => {


        const peer = peers.find((d) => d.peerId === userId);
        return [
          ...peers.filter((d) => !d.share),
          {
            peerId: `share_${userId}`,
            peerName: `${peer ? peer.peerName : ""}-н дэлгэц`, // todo 用户名应由sdk返回
            share: true,
            video: true,
            videoTrack: remoteTrack
          },
        ];
      });
    } catch (error) {
      console.log(`[USE-RTC] startRemoteShare error: ${error}`);
    }
  }

  const stopRemoteShare = async (userId: string) => {
    try{
      await window.roomClient.unsubscribeShare(userId);
      setParticipants((peers) =>
      peers.map((d) => {
        if (d.peerId ===  `share_${userId}`) {
          return { ...d, video: false, videoTrack: null };
        }
        return d;
      })
    );
   }catch(error){

   }
  };


  const startRemoteVideo = async (userId: string) =>{
    //已经在subscribeVideo中做了防止重复订阅的策略
     try{
        const remoteTrack = await window.roomClient.subscribeVideo(userId);
        console.log(`[USE-RTC] startRemoteVideo userId=${userId}`);
        setParticipants((peers) =>
        peers.map((d) => {
          if (d.peerId === userId) {
            console.log(`[USE-RTC] startRemoteVideo d.peerId=${d.peerId} userId=${userId}`);
            if(!d.videoTrack){
              return { ...d, video: true, videoTrack: remoteTrack };
            }
          }
          return d;
        })
      );
     }catch(error){
        console.log(`[USE-RTC] startRemoteVideo error: ${error}`);
     }
  }

  const stopRemoteVideo = async (userId: string) => {
    try{
      await window.roomClient.unsubscribeVideo(userId);
      setParticipants((peers) =>
      peers.map((d) => {
        if (d.peerId === userId) {
          if(d.videoTrack){
            return { ...d, video: false, videoTrack: null };
          } 
        }
        return d;
      })
    );
   }catch(error){

   }
  };

  const setParticipantInActivePage = async (userId: string, bInActivePage: boolean) => {
    for (const participant of participants){
      if (participant.peerId === userId) {
        participant.bInActivePage = bInActivePage;
        console.log(`[DEBUG] [USE-RTC] setParticipantInActivePage userId=${userId} bInActivePage=${bInActivePage}`,JSON.stringify(participant));
        if(bInActivePage){
          await startRemoteVideo(userId);
        }else{
          await stopRemoteVideo(userId);
        }
        break;
      } else {
        // participant.isHost =false
        // participant.roleCode=0
      }
    }
  }

  const openElectronShare = async (shareSource: MediaStream) => {
    await window.roomClient.startScreenCaptureForElectron(shareSource);
  };
//  切换到演讲者视图模式
  const switchToSpeakerView = () => {
  setSpeakerViewMode( "speaking");
};

//  切换到其他视图模式
const switchToOtherView = () => {
  setSpeakerViewMode("");
};
  const closeElectronShare = async () => {
    await window.roomClient.stopScreenCaptureForElectron();
  };

  const openShare = async () => {
    console.log("[APP] opening share!");
    const encParams: QRTCVideoEncParams = {
      videoResolution: QRTCVideoResolution.QRTCVideoResolution_1920_1080,
      resMode: QRTCVideoResolutionMode.QRTCVideoResolutionModeLandscape,
      videoFps: 9,
      minVideoBitrate: 1500,
      maxVideoBitrate: 4200,
    };

    await window.roomClient.startScreenCapture(encParams);
  };

  const muteLocalVideo = () => {};

  const unMuteLocalVideo = async () => {
    await window.roomClient.muteLocalVideo(false);
  };

  const stopLocalAudio = async () => {
    console.log(`[APP] stopLocalAudio`);
    await window.roomClient.stopLocalAudio();
    setParticipants((peers) =>
      peers.map((d) => {
        if (d.local) {
          return { ...d, audio: false };
        }
        return d;
      })
    );
  };

  const startLocalAudio = async () => {
    console.log(`[APP] startLocalAudio`);
    await window.roomClient.startLocalAudio();
    setParticipants((peers) =>
      peers.map((d) => {
        if (d.local) {
          return { ...d, audio: true };
        }
        return d;
      })
    );
  };

  const muteLocalAudio = async (mute: boolean) => {
    await window.roomClient.muteLocalAudio(mute);
  };

  const muteAllRemoteAudios = async () => {
    await window.roomClient.muteAllRemoteAudios(true);
  };

  const unMuteAllRemoteAudios = async () => {
    await window.roomClient.muteAllRemoteAudios(false);
  };

  const muteAllRemoteViews = async () => {
    await window.roomClient.muteAllRemoteViews(true);
  };

  const unMuteAllRemoteViews = async () => {
    await window.roomClient.muteAllRemoteViews(false);
  };

  const pin = (userId: string, pinned: boolean) => {
    console.log(`[APP] pin`);
    setParticipants((peers) =>
      peers.map((d) => {
        if (d.peerId === userId) {
          return { ...d, pinned };
        }
        return { ...d, pinned: false };
      })
    );
  };

  const close = async () => {
    await window.roomClient.close();
  };

  const sendCustomCmdMsg = async (d: any) => {
    console.log(`send sendCustomCmdMsg: ${d}`);
    const { cmdId = 1, data } = d;
    await window.roomClient.sendCustomCmdMsg(cmdId, data);
  };

  const updateConference = (conf: ConferenceInterface) => {
    setCoference(conf);
    // window.localStorage.setItem(METTINGPAGE_SAVED_MEETING_INFO, conf as any);
  };
  const openMic=()=>{
    window.roomClient.startLocalAudio();
  }
  const closeMic=()=>{
    window.roomClient.stopLocalAudio();
  }
  const updateParticipants = () => {
    _setParticipants([...participants]);
  }

  return {
    // board: {
    //   boardShow,
    //   setBoardShow,
    //   boardItems,
    //   setBoardItems,
    //   setBoardSize,
    // },
    participants,
    conference,
    updateConference,
    setParticipants,
    // 
    service: {
      switchToSpeakerView,
      switchToOtherView,
      openShare,
      openElectronShare,
      closeElectronShare,
      startLocalPreview,
      stopLocalPreview,
      startRemoteVideo,
      stopRemoteVideo,
      setParticipantInActivePage,
      muteLocalVideo,
      unMuteLocalVideo,
      stopLocalAudio,
      startLocalAudio,
      muteLocalAudio,
      muteAllRemoteAudios,
      unMuteAllRemoteAudios,
      muteAllRemoteViews,
      unMuteAllRemoteViews,
      pin,
      setParticipants, //暴露给外部的方法
      close,
      sendCustomCmdMsg,
      setAudioPlayoutVolume,
      setCurrentMic,
      setCurrentCameraDevice,
      
      setCurrentSpeaker,
      updateParticipants,
      openMic ,
      closeMic,
     
    },
  };
};

export default useRtc;
